<template>
   <div>
      <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />

      <div class="auth-wrapper auth-v2">
         <div class="row auth-inner m-0">
            <div class="d-none d-lg-flex align-items-center p-5 col-lg-7" style="background-color: #f8f8f8">
               <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                  <img src="/images/search-account.png" alt="Register V2" class="img-fluid" />
               </div>
            </div>
            <div class="d-flex align-items-center auth-bg px-2 p-lg-5 col-lg-5">
               <div class="px-xl-2 mx-auto col-sm-8 col-md-6 col-lg-12">
                  <center><img src="/images/sbc-logo.png" alt="SBC logo" class="img-fluid mt-3 mt-md-0"
                        style="height:75px;"></center>
                  <p class="font-weight-bold mb-1 fs-24 mt-4">Find your account</p>
                  <p class="card-text mb-2">
                     Please input your personal information to search for your account.
                  </p>

                  <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <span>
                     <div class="auth-register-form mt-2 mb-3 mb-md-0">
                        <div class="form-group">
                           <label>First Name</label>
                           <input type="text" autocomplete="false" class="form-control text-uppercase" @input="onInput($event, 'firstname')" v-model="form.firstname"
                              :class="{ 'is-invalid': $v.form.firstname.$error }" />
                        </div>
                        <div class="form-group mb-0">
                           <label>Middle Name</label>
                           <input type="text" autocomplete="false" class="form-control text-uppercase" @input="onInput($event, 'middlename')" v-model="form.middlename"
                              :class="{ 'is-invalid': $v.form.middlename.$error }" :disabled="no_middlename" />
                        </div>
                        <div class="form-group">
                           <div class="custom-control custom-checkbox">
                              <input id="nm" type="checkbox" class="custom-control-input" v-model="no_middlename"
                                 @change="form.middlename = ''" />
                              <label for="nm" class="custom-control-label">Click here if no middle name</label>
                           </div>
                        </div>
                        <div class="form-group">
                           <label>Last Name</label>
                           <input type="text" autocomplete="false" class="form-control text-uppercase" @input="onInput($event, 'lastname')" v-model="form.lastname"
                              :class="{ 'is-invalid': $v.form.lastname.$error }" />
                        </div>

                        <div class="form-group">
                           <label>Suffix</label>
                           <select id="ss" class="form-control" v-model="form.suffix_code">
                              <option value="" selected>- Select -</option>
                              <option v-for="suffix in suffixes" :key="suffix.suffix_code" :value="suffix.suffix_code">
                                 {{ suffix.suffix_desc }}
                              </option>
                           </select>
                        </div>
                        <div>
                           <label>Date of Birth</label>
                           <div class="form-group d-flex">
                              <select id="mm" style="width: 100%" class="custom-select" v-model="form.month"
                                 :class="{ 'is-invalid': $v.form.month.$error }" @change="updateAvailableDates()">
                                 <option value="" selected disabled>Month</option>
                                 <option v-for="(month, i) in months" :value="month.value" :key="i">
                                    {{ month.label }}
                                 </option>
                              </select>

                              <select id="dd" style="width: 100px" class="custom-select mx-1" v-model="form.day"
                                 :class="{ 'is-invalid': $v.form.day.$error }">
                                 <option value="" selected disabled>Day</option>
                                 <option v-for="(day, i) in days" :value="day" :key="i">
                                    {{ day }}
                                 </option>
                              </select>

                              <select id="yy" style="width: 110px" class="custom-select" v-model="form.year"
                                 :class="{ 'is-invalid': $v.form.year.$error }" @change="updateAvailableDates()">
                                 <option value="" selected disabled>Year</option>
                                 <option v-for="(year, i) in years" :value="year" :key="i">
                                    {{ year }}
                                 </option>
                              </select>

                           </div>
                        </div>

                        <div class="form-group">
                           <div class="custom-control custom-checkbox">
                              <input id="agree" type="checkbox" v-model="agree" class="custom-control-input" />
                              <label for="agree" class="custom-control-label">
                                 I agree to <a href="pdf/SBC-Privacy-Policy-and-Notice.pdf" target="_blank">privacy policy &amp; terms</a>
                              </label>
                           </div>
                        </div>

                        <div class="row mt-2">
                           <div class="col-6">
                              <a class="btn btn-outline-primary px-3" href="/login">
                                 <i class="fas fa-arrow-left mr-2"></i>Back
                              </a>
                           </div>
                           <div class="col-6">
                              <button class="btn btn-primary float-right px-3" @click="btnSubmit" :disabled="!agree">
                                 Submit<i class="fas fa-arrow-right ml-2"></i>
                              </button>
                           </div>
                        </div>
                     </div>
                  </span>
               </div>
            </div>
         </div>
      </div>

      <div id="sq" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title">
                     <i class="fas fa-user-shield mr-1"></i> Security Question
                  </h5>
               </div>
               <div class="modal-body">


                  <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=0">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <div class="form-group">
                     <p class="mb-0">{{question.description}}</p>
                     <p class="fs-14"><em>( {{question.tagalog}} )</em></p>
                     <input type="text" autocomplete="false" class="form-control text-uppercase" placeholder="Enter your answer" :disabled="attempt===3"
                        v-model="answer" :class="{ 'is-invalid': $v.answer.$error }" />
                  </div>
               </div>
               <div class="modal-footer">
                  <button class="btn btn-outline-primary px-3 mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-primary px-3" @click="contactSB()" v-if="attempt===3">
                     Contact SB Corp
                  </button>
                  <button class="btn btn-primary px-3" @click="btnSubmitSQ()" v-else>
                     Submit
                  </button>
               </div>
            </div>
         </div>
      </div>

      <div id="sbcorp" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title">
                     Contact SB Corp
                  </h5>
               </div>
               <div class="modal-body">
                  <!-- <h5>Contact SB Corp</h5> -->
                  <p>We're here to listen.</p>
                  <p>Start by using our feedback form and we'll get back to you soonest.</p>
                  <hr />

                  <h6><b>Personal Information</b></h6>
                  <div class="row">
                     <div class="col-md-7">
                        <p>Name
                           <b class="d-block">{{name | uppercase}}</b>
                        </p>
                     </div>
                     <div class="col-md-5">
                        <p>Birthdate
                           <b class="d-block">{{birthdate | MM/DD/YYYY}}</b>
                        </p>
                     </div>
                  </div>
                  <div class="row" v-if="registered_email">
                     <div class="col-md-12">
                        <p>Registered Email
                           <b class="d-block">{{registered_email}}</b>
                        </p>
                     </div>
                  </div>

                  <div class="alert alert-danger2 alert-dismissible" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=false">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <div class="reg">
                     <div class="form-label-group">
                        <input id="em" type="text" autocomplete="false" class="form-control" placeholder="Working Email" v-model="contact.working_email" :class="{ 'is-invalid': $v.contact.working_email.$error }">
                        <label for="em">Working Email</label>
                        <small v-if="$v.contact.working_email.$error && contact.working_email" class="text-danger">Invalid email format</small>
                     </div>

                     <div class="form-label-group">
                        <input id="mob" type="text" autocomplete="false" class="form-control" placeholder="Working Mobile No." v-input-mask data-inputmask-mask="9999 999 9999" data-inputmask-placeholder="" v-model="contact.working_mobile" :class="{ 'is-invalid': $v.contact.working_mobile.$error }">
                        <label for="mob">Working Mobile No.</label>
                        <small class="text-muted">ex. 0912 345 6789</small>
                     </div>

                  </div>

                  <h6><b>Details of Concern</b></h6>

                  <div class="form-group">
                     <select class="custom-select custom-select-sm" :style="{ color: selectColor }" v-model="contact.purpose" :class="{ 'is-invalid': $v.contact.purpose.$error }"
                        @change="selectColor='#495057'">
                        <option value="" selected disabled>Purpose</option>
                        <option value="1">Update email address</option>
                     </select>
                  </div>

                  <!-- <div class="form-group">
                     <textarea class="form-control" rows="3" placeholder="Summary of concern (optional)" v-model="contact.remarks"></textarea>
                  </div> -->

                  <h6><b>Attach Proof</b></h6>

                  <div class="row">
                     <div class="col-md-12">
                        <div class="form-group">
                           <p class="fs-15 mb-0">Upload Valid Government Issued ID</p>
                           <a href="javascript:void(0)" class="fs-14" @click="openSample('/images/gov-id.jpg')">Click here to see a sample</a>
                           <div class="input-group mt-2">
                              <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="gov_id"
                                 @change="uploadAttach('gov_id', $event)" />
                              <input type="text" autocomplete="false" class="form-control form-control-sm ro" readonly :class="{ 'is-invalid': $v.attach.gov_id.$error }"
                                 @click="browseRef('gov_id')" :value="attach.gov_id ? attach.gov_id.name : 'Choose a file..'" />
                              <div class="input-group-append">
                                 <button class="btn btn-sm btn-outline-primary" @click="browseRef('gov_id')">{{attach.gov_id ? 'Change' : 'Attach'}}</button>
                                 <button v-if="attach.gov_id" class="btn btn-sm btn-outline-primary ml-2" @click="viewFile(attach.gov_id)">View</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div class="row">
                     <div class="col-md-12">
                        <div class="form-group">
                           <p class="fs-15 mb-0">Upload Selfie Holding the Government Issued ID</p>
                           <a href="javascript:void(0)" class="fs-14" @click="openSample('/images/selfie-id.jpg')">Click here to see a sample</a>
                           <div class="input-group mt-2">
                              <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="selfie" @change="uploadAttach('selfie', $event)" />
                              <input type="text" autocomplete="false" class="form-control form-control-sm ro" readonly :class="{ 'is-invalid': $v.attach.selfie.$error }"
                                 @click="browseRef('selfie')" :value="attach.selfie ? attach.selfie.name : 'Choose a file..'" />
                              <div class="input-group-append">
                                 <button class="btn btn-sm btn-outline-primary" @click="browseRef('selfie')">{{attach.selfie ? 'Change' : 'Attach'}}</button>
                                 <button v-if="attach.selfie" class="btn btn-sm btn-outline-primary ml-2" @click="viewFile(attach.selfie)">View</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="modal-footer">
                  <button class="btn btn-outline-primary px-3 mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-primary px-3" @click="btnSubmitContact">
                     Submit
                  </button>
               </div>

            </div>

         </div>
      </div>

      <div id="email" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-md modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title">
                     Check Email Status
                  </h5>
               </div>
               <div class="modal-body">
                  <div class="alert alert-info2 mt-2">
                     <div class="alert-body">
                        <span class="text-justify">We have detected that <b>{{registered_email}}</b> has not been verified by our system. Is this email address still accessible and being used?</span>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button class="btn btn-outline-primary mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-outline-primary" @click="modalUpdateEmail">
                     No, update my email
                  </button>
                  <button class="btn btn-primary" @click="gotoLogin">
                     Yes, still accessible
                  </button>
               </div>
            </div>
         </div>
      </div>

      <div class="modal fade" id="updateEmail" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
         <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Update Email</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div class="modal-body">

                  <div class="alert alert-danger2 alert-dismissible" role="alert" v-if="error">
                     <button type="button" class="close mt-n1" data-dismiss="alert" @click="error=false">&times;</button>
                     <a target="#err0" hidden id="err"></a>
                     <div class="alert-body">
                        <p v-if="error_message && errors.length == 0" class="mb-0">
                           {{ error_message }}
                        </p>
                        <div v-for="(v, k) in errors" :key="k">
                           <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                        </div>
                     </div>
                  </div>

                  <div class="form-group">
                     <label>Registered email address</label>
                     <input class="form-control" :value="registered_email" disabled>
                  </div>

                  <div class="form-group">
                     <label>New email address</label>
                     <input class="form-control text-lowercase" v-model="email" :class="{ 'is-invalid': $v.email.$error }" @input="preventSpace">
                     <span class="fs-12 text-danger" v-if="$v.email.$error && email">Please enter a valid email address</span>
                     <span class="fs-12 text-danger" v-if="$v.email.$error && !email">This field is required</span>
                  </div>

               </div>
               <div class="modal-footer">
                  <button class="btn btn-outline-primary px-3 mr-auto" data-dismiss="modal">
                     Cancel
                  </button>
                  <button class="btn btn-primary px-3" @click="btnUpdate()">
                     Submit
                  </button>
               </div>
            </div>
         </div>
      </div>

   </div>
</template>

<script>
   import {
      days,
      months,
      years
   } from "./date-array"
   import {
      required,
      requiredIf,
      email
   } from "vuelidate/lib/validators";
   export default {
      props: {
         suffixes: {
            type: Array,
            required: true
         }
      },
      data() {
         return {
            purpose: '',
            selectColor: '#90949c',
            days: days,
            months: months,
            years: years,
            attempt: 0,

            form: {
               firstname: "",
               middlename: "",
               lastname: "",
               suffix_code: "",

               day: "",
               month: "",
               year: ""
            },

            attach: {
               gov_id: '',
               selfie: ''
            },

            no_middlename: false,
            agree: false,

            user_id: '',
            question: {},
            loader: 0,
            answer: '',

            error: false,
            errors: [],
            error_message: '',

            registered_email: '',
            email: '',

            contact: {
               working_email: '',
               working_mobile: '',
               purpose: '',
               remarks: '',
            },
         };
      },
      computed: {
         birthdate() {
            const {
               day,
               month,
               year
            } = this.form;
            if (!day || !month || !year) {
               return "-";
            }
            return `${year}-${month}-${day}`;
         },
         name() {
            if (!this.form.lastname && !this.form.firstname) {
               return ''; // Return an empty string if user is not defined
            }
            const {
               firstname,
               middlename,
               lastname,
               suffix_code
            } = this.form;

            const suffix_desc = _.get(_.find(this.suffixes, {
               suffix_code
            }), 'suffix_desc', '');

            const mname = middlename === 'NMN' ? '' : middlename;
            const nameParts = [firstname, mname, lastname, suffix_desc].filter(part => part); // Filter out undefined or null parts
            return nameParts.join(' ').trim();
         },
         processingAPI() {
            return this.loader > 0;
         },
      },
      validations() {
         return {
            email: {
               required,
               email
            },
            form: {
               firstname: {
                  required
               },
               middlename: {
                  required: requiredIf(function() {
                     return !this.no_middlename;
                  })
               },
               lastname: {
                  required
               },

               day: {
                  required
               },
               month: {
                  required
               },
               year: {
                  required
               },
            },
            attach: {
               gov_id: {
                  required
               },
               selfie: {
                  required
               },
            },
            contact: {
               working_email: {
                  required,
                  email
               },
               working_mobile: {
                  required
               },
               purpose: {
                  required
               },
            },
            answer: {
               required
            },
         };
      },
      methods: {
         preventSpace(){
            this.email = this.email.replace(/\s+/g, '');
         },
         btnUpdate() {
            this.$v.email.$touch();
            if (this.$v.email.$invalid) {
               return;
            } else {
               this.apiUpdateEmail()
            }
         },
         apiUpdateEmail() {
            this.loader++;
            axios
               .post("/email-update", {
                  id: this.user_id,
                  email: this.email
               })
               .then((res) => {
                  this.loader--;
                  $("#updateEmail").modal("hide");
                  Swal.fire({
                     icon: 'success',
                     title: 'Success',
                     text: 'Your email address has been updated. Kindly log in using the new email address.',
                     allowOutsideClick: false,
                     allowEscapeKey: false,
                     allowOutsideClick: false,
                  }).then((result) => {
                     location.href = '/login';
                  });
               })
               .catch((err) => {
                  this.loader--;
                  this.error = 1;
                  if (err.response && err.response.data) {
                     this.errors = err.response.data.errors || [];
                     this.error_message = err.response.data.message;
                  } else {
                     this.error_message = 'Transaction Failed'
                  }
               });
         },

         modalUpdateEmail() {
            $("#email").modal("hide");
            $("#updateEmail").modal("show");
         },
         onInput(event, key) {
            const val = event.target.value;
            this.$set(this.form, key, val.replace(/\s{2,}/g, ' '));
         },
         contactSB() {
            $("#sq").modal("hide");
            $("#sbcorp").modal("show");
         },
         openSample(path) {
            Swal.fire({
               imageUrl: path,
               imageHeight: 225,
               imageAlt: "picture"
            });
         },
         apiSubmitContactForm() {
            const {
               firstname,
               middlename,
               lastname,
               suffix_code
            } = this.form;
            const {
               working_email,
               working_mobile,
               purpose,
               remarks
            } = this.contact;
            const {
               gov_id,
               selfie,
            } = this.attach;

            const formData = new FormData();
            formData.append('firstname', firstname);
            formData.append('middlename', middlename || 'NMN');
            formData.append('lastname', lastname);
            formData.append('suffix_code', suffix_code || '');

            formData.append('working_email', working_email);
            formData.append('working_mobile', working_mobile);
            formData.append('purpose', purpose);
            formData.append('remarks', remarks);

            formData.append('gov_id', gov_id);
            formData.append('selfie', selfie);

            formData.append('birthdate', this.birthdate);
            formData.append('registered_email', this.registered_email || '');

            this.loader++;

            axios
               .post("/forgot-account-contact-sbcorp", formData)
               .then((res) => {
                  $("#sbcorp").modal("hide");
                  this.loader--;
                  const data = res.data;
                  const msg = data.message;

                  Swal.fire({
                     title: "Notice",
                     html: `<p class="fs-18">${msg}</p>`,
                     icon: "success",
                     allowEscapeKey: false,
                     allowOutsideClick: false
                  }).then((result) => {
                     location.href = '/login';
                  });
               })
               .catch((err) => {
                  this.loader--;
                  this.error = 1;
                  if (err.response && err.response.data) {
                     this.errors = err.response.data.errors || [];
                     this.error_message = err.response.data.message;
                  } else {
                     this.error_message = 'Transaction Failed'
                  }
               });
         },
         btnSubmitContact() {
            this.$v.attach.$touch();
            this.$v.contact.$touch();
            if (this.$v.attach.$invalid || this.$v.contact.$invalid) {
               return;
            } else {
               this.apiSubmitContactForm()
            }
         },
         uploadAttach(el, ev) {
            let file = ev.target.files[0];
            const allowedTypes = new Set([
               "image/jpeg",
               "image/png",
               "image/jpg",
               "application/pdf"
            ]);

            const maxSize = 10 * 1024 * 1024; // 10 MB

            if (!file) return;

            const {
               type,
               size
            } = file;

            if (!allowedTypes.has(type.toLowerCase())) {
               this.swalInfo('Invalid file type. Please upload a JPEG, PNG, JPG, or PDF file.')
               return;
            }

            if (size > maxSize) {
               this.swalInfo('File size exceeds 10 MB. Please upload a smaller file.')
               return;
            }
            this.attach[el] = file;
         },
         viewFile(file) {
            const supportedTypes = [
               'application/pdf',
               'image/jpeg',
               'image/png',
               'image/gif',
               'audio/mpeg',
               'audio/ogg',
               'audio/wav',
               'video/mp4',
               'video/webm',
               'video/ogg'
            ];
            const url = window.URL.createObjectURL(file);
            if (supportedTypes.includes(file.type)) {
               const popup = window.open(url, '_blank', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes');
               if (!popup) {
                  alert('Unable to open a new window/tab. This might be due to your browser blocking pop-ups. Please check your browser settings to allow pop-ups or try again.');
               }
            } else {
               const link = document.createElement('a');
               link.href = url;
               link.download = file.name;
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
            }
            window.URL.revokeObjectURL(url)
         },
         swalInfo(text) {
            Swal.fire({
               icon: 'warning',
               title: 'Error',
               text: text,
               allowEscapeKey: false,
               allowOutsideClick: false,
            })
         },
         browseRef(id) {
            document.getElementById(id).click();
         },
         btnSubmitSQ() {
            this.$v.answer.$touch();
            if (this.$v.answer.$invalid) {
               return;
            } else {
               this.apiSubmitSQ();
            }
         },
         gotoLogin() {
            Swal.fire({
                  icon: "success",
                  title: 'Success',
                  allowOutsideClick: false,
                  confirmButtonText: "Go to login",
               })
               .then((result) => {
                  location.href = '/login';
               })
         },
         swalEmail(email) {
            Swal.fire({
               icon: "info",
               html: `<p class="fs-18 mb-2"><b>We would like to confirm if your email address is still up-to-date and accessible.</b></p>` +
                  `<p class="fs-16 mx-n2 mb-1">Registered Email: <i><b>${email}</b></i></p>`,
               allowOutsideClick: false,
               showCancelButton: true,
               confirmButtonText: "Yes, still accessible",
               cancelButtonText: "No, update my email",
               reverseButtons: true,
            }).then((result) => {
               if (result.isConfirmed) {
                  this.gotoLogin();
               } else {
                  $("#updateEmail").modal("show");
               }
            });
         },
         apiSubmitSQ() {
            this.loader++;
            const payload = {
               user_id: this.user_id,
               sq_id: this.question.id,
               answer: this.answer
            }
            axios
               .post("/forgot-account-answer", payload)
               .then((res) => {
                  $("#sq").modal("hide");
                  this.loader--;
                  const data = res.data;
                  if (data.email) {
                     this.swalEmail(data.email);
                     this.registered_email = data.email;
                     this.user_id = data.user_id;
                  }
               })
               .catch((err) => {
                  this.loader--;
                  this.error = 1;
                  this.attempt++;

                  if (this.attempt === 3) {
                     this.error_message = `You've reached the limit for answering the security question. Please try again later or contact SB Corp.`
                  } else {
                     this.error_message = 'It looks like the answer you provided does not match our records. Please try again.'
                  }
                  if (err.response && err.response.data) {
                     this.errors = err.response.data.errors || [];
                  }
               });
         },
         apiSubmit() {
            this.loader++;
            const {
               firstname,
               middlename,
               lastname,
               suffix_code
            } = this.form;

            const payload = {
               firstname: firstname,
               middlename: middlename || 'NMN',
               lastname: lastname,
               suffix_code: suffix_code,
               birthdate: this.birthdate
            }
            axios
               .post("/forgot-account", payload)
               .then((res) => {
                  this.loader--;
                  const data = res.data;
                  const hit = data.hit;
                  const msg = data.message;

                  this.user_id = data.user_id || '';
                  this.registered_email = data.email || '';

                  console.log(data);
                  switch (hit) {
                     case -1:
                        Swal.fire({
                           title: "Notice",
                           html: `${msg}`,
                           icon: "info",
                           allowEscapeKey: false,
                           allowOutsideClick: false
                        }).then((result) => {
                           location.href = '/login';
                        });
                        break;
                     case 0:
                        Swal.fire({
                           icon: 'warning',
                           title: 'Oops...',
                           html: `<p class="fs-17 mb-3">It seems that we don't have your record on file, kindly click the "Create New Account" in the BRS website.</p>`,
                           allowOutsideClick: false,
                           allowEscapeKey: false,
                        }).then((result) => {
                           location.href = '/login';
                        });
                        break;
                     case 1:
                        $("#email").modal("show");
                        break;
                     case 2:
                        $("#sbcorp").modal("show");
                        break;
                     case 3:
                        this.question = data.question;
                        $("#sq").modal("show");
                        break;
                     default:
                        break;
                  }
               })
               .catch((err) => {
                  this.loader--;
                  console.log(err);
               });
         },

         btnSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
               this.error_message = 'Please complete all the required fields';
               this.error = 1;
            } else {
               this.error_message = '';
               this.error = 0;
               this.apiSubmit();
            }
         },
         updateAvailableDates() {
            const m = parseInt(this.form.month) || 1;
            const y = parseInt(this.form.year) || 2000;
            const d = parseInt(this.form.day) || 1;
            const daysInMonth = new Date(y, m, 0).getDate();
            this.days = Array.from({
               length: daysInMonth
            }, (_, i) => {
               const n = i + 1;
               return n < 10 ? "0" + n : String(n);
            });

            if (d > daysInMonth) {
               this.form.day = "";
            }
         },
      },
      mounted() {
         $('#updateEmail').on('hidden.bs.modal', (event) => {
            this.error = 0;
            this.errors = [];
            this.error_message = '';
            this.email = '';
         })
         $('#sq').on('hidden.bs.modal', (event) => {
            this.answer = '';
            this.error = 0;
            this.errors = [];
            this.error_message = '';
         })
         $('#sbcorp').on('hidden.bs.modal', (event) => {
            this.attach.gov_id = '';
            this.attach.selfie = '';
         })
      },
   };
</script>